import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

const Outer = styled.h2`
  text-align: center;
  font-weight: 600;
  font-size: 1.75rem;
  letter-spacing: 0.2em;
  line-height: 2;
  @media (max-width: 40rem){
    font-size: 1.6rem;
    line-height: 1.7;
  }
`

type TitleProps = {

}
export const Title: FunctionComponent<TitleProps> = ({children}) => {
  return <Outer>
    {children}
  </Outer>
}